import {type Mock, vi} from 'vitest'
/** @internal */
export const getGlobalCliClient: Mock = vi.fn()
/** @internal */
export const getProjectCliClient: Mock = vi.fn()
